import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { InlineBanner } from '@wirtualna-polska/n2cr-ds'
import { IBannerSaga } from '@ads/front-core/store/sagas/bannerSaga'
import { hideBanner } from '@ads/front-core/store/reducers/banner/hideBannerReducer'
import { overBanner } from '@ads/front-core/store/reducers/banner/overBannerReducer'

interface BannerItemProps {
  id: string
  banner: IBannerSaga
}

const BannerItem: FC<BannerItemProps> = ({ id, banner }) => {
  const dispatch = useDispatch()

  const onClose = () => {
    dispatch(hideBanner({ id }))
  }

  const onMouseOver = () => {
    dispatch(overBanner({ id }))
  }

  return (
    <BannerWrapper onMouseOver={onMouseOver}>
      <InlineBanner
        {...banner}
        onCloseClick={
          !banner.disableClose && banner.overBanner ? onClose : undefined
        }
      />
    </BannerWrapper>
  )
}

const BannerWrapper = styled.div``

export default BannerItem
